module.exports = __webpack_public_path__ + "h5/static/img/goko-logo.8c02dd0f.png";